module.exports = __webpack_public_path__ + "static/media/delantal (3).6bc6767e.jpg";